import React from "react";
import { Controller } from "react-hook-form";
import DatePicker, {
  validateDate,
} from "../../../components/forms/DateTimePicker/DatePicker";
import Select from "../../../components/forms/Select/Select";

const PersonalDetails = ({ control, errors, genders, nationalities, user }) => {
  return (
    <div className="space-y-4">
      {/* Date of Birth */}
      <Controller
        name="date_of_birth"
        control={control}
        defaultValue={user.date_of_birth}
        rules={{
          required: "Date of birth is required",
          validate: (value) => validateDate(value),
        }}
        render={({ field, fieldState }) => (
          <DatePicker
            label="Date of Birth"
            name={field.name}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            error={fieldState.error}
            darkMode={true}
            required
          />
        )}
      />

      {/* Gender */}
      <div className="flex flex-col">
        <label className="text-sm mb-1 font-semibold text-gray-900 dark:text-gray-200">
          Gender<span className="text-red-500">*</span>
        </label>
        <Controller
          name="gender"
          control={control}
          defaultValue={user.gender?.uuid}
          // rules={{
          //   validate: (value) =>
          //     value !== '-' || 'Please select a valid gender',
          // }}
          render={({ field }) => (
            <Select
              options={genders}
              placeholder="Select Gender"
              value={field.value}
              onChange={(v) => {
                field.onChange(v.value);
              }}
            />
          )}
        />
        {errors.gender && (
          <p className="text-red-500 text-xs mt-1">{errors.gender.message}</p>
        )}
      </div>

      <Controller
        name="nationality"
        control={control}
        defaultValue={user.nationality || ""}
        rules={{ required: "Nationality is required" }}
        render={({ field }) => (
          <Select
            label="Nationality"
            required
            isSearchable
            options={nationalities}
            placeholder="Select nationality"
            value={field.value}
            onChange={(option) => field.onChange(option.value)}
            errorMsg={errors.nationality?.message}
          />
        )}
      />
    </div>
  );
};

export default PersonalDetails;
